// extracted by mini-css-extract-plugin
export default {"container":"PricingRadio_container__5xVQk","labela":"PricingRadio_labela__p4FTK","inputg":"PricingRadio_inputg__jlzEb","spang":"PricingRadio_spang__cqSJk"};